import Ajax from '@lib/ajax'

export default {

  async create(payload){
    return Ajax.post('/api/services/app/User/Create', payload);
  },
  async update(payload){
    return Ajax.put('/api/services/app/User/Update', payload);
  },
  async delete(id){
    return Ajax.delete('/api/services/app/User/Delete?Id='+ id);
  },
  async get(id){
    return Ajax.get('/api/services/app/User/Get?Id='+ id);
  },
  async getAll(payload){
    return Ajax.get('/api/services/app/User/GetAll',{params:payload.data});
  },
  async getRoles(){
    return Ajax.get('/api/services/app/User/GetRoles');
  },
  async getUsersGridResult(payload){
    return Ajax.get('/api/services/app/User/GetUsersGridResult', payload);
  }
  
}